import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import { useRef, useLayoutEffect, useState, useCallback } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
/**
 *
 * @param {(ResizeObserverEntry) => any} resizedCallback
 * @returns {Dispatch}
 */

var useResizeObserver = function useResizeObserver(resizedCallback) {
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      node = _useState2[0],
      setNode = _useState2[1];

  var observer = useRef(null);
  var disconnect = useCallback(function () {
    var current = observer.current;
    current && current.disconnect();
  }, []);
  var observe = useCallback(function () {
    observer.current = new ResizeObserver(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          entry = _ref2[0];

      resizedCallback && resizedCallback(entry);
    });
    node && observer.current.observe(node);
  }, [node]);
  useLayoutEffect(function () {
    observe();
    return function () {
      return disconnect();
    };
  }, [disconnect, observe]);
  return setNode;
};

export default useResizeObserver;